import styled, { css } from 'styled-components'
import { SCalc, SDevider } from '@components/Cacl'
import { above } from '@styles/mixins/breakpoints'
import {
  SH3,
  SH4,
  SParagraph,
  STypographyDefault,
  withTypographyDesc,
  withTypographyDisclaimer,
} from '@components/Typography'
import { colors } from '@styles/theme'
import { SWideButton } from '@components/Benefits/Card'
import { SButtonTabAero } from '@components/Questions/styled'
import Box from '@components/Box'
import AttentionIcon from '@icons/attention.inline.svg'
import { IWithHidden } from '@components/CalcAero/types'

export const SCalcAero = styled(SCalc)`
  margin-bottom: 48px;

  ${above('md')(css`
    padding: 40px;
  `)}

  ${above('xl')(css`
    padding: 40px 52px;
    display: flex;
    flex-direction: row;
  `)}
`

/*
const STip = styled(STypographyDefault)`
  font-size: 12px;
  line-height: 16px;
  color: ${colors.darkGray};
`*/

/*const SMark = styled(STip)`
  display: inline;
  color: ${colors.orange};
  text-decoration: underline;
`
*/

export const SDisclaimerContainer = styled.div<IWithHidden>`
  border-radius: 4px;
  background-color: ${colors.pink};
  padding: 16px;
  display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
`

export const SAttentionIcon = styled(AttentionIcon)`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`

export const SDisclaimerText = styled.p`
  ${withTypographyDisclaimer};
  margin: 0 0 0 14px;
  color: ${colors.darkRed};
`

export const Divider = styled(SDevider)`
  margin: 24px 0;

  ${above('xl')(css`
    margin: 0 52px;
  `)}
`

export const SOverlay = styled.div<IWithHidden>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: white;
  opacity: 0.5;
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
`

export const SResultTitle = styled(SH3)`
  font-weight: 400;
  color: ${colors.darkGray};

  ${above('md')(css`
    margin-right: 150px;
  `)}
`

export const SSum = styled(SParagraph)`
  font-size: 44px;
  line-height: 52px;
  color: ${colors.darkBlue};
  margin: 20px 0 4px;

  ${above('md')(css`
    font-size: 60px;
    line-height: 64px;
    margin-top: 12px;
    margin-bottom: 4px;
  `)}
`

export const SSumCaption = styled.p`
  margin-top: 0;
  margin-bottom: 20px;
  ${withTypographyDesc};
  color: ${colors.gray};
`

export const SButtonConclude = styled(SWideButton)`
  &:hover {
    border-color: ${colors.darkBlue};
    background-color: ${colors.darkBlue};
  }

  ${above('md')(css`
    width: auto;
  `)}
`

export const SContractForm = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  color: ${colors.orange};
  margin: 20px auto 0;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  ${above('md')(css`
    margin: auto auto auto 24px;
  `)}
`

/*
const STaxDeduction = styled(SParagraph)`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.graphite};
  margin-right: 70px;
  margin-top: 16px;
  margin-bottom: 20px;

  ${above('md')(css`
    margin-top: 0;
    margin-bottom: 24px;
  `)}
`
*/

export const SCalcCaption = styled(SParagraph)`
  margin: 0;
  display: block;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.darkGray};
`

export const SButtonTab = styled(SButtonTabAero)`
  justify-content: center;
  margin-bottom: 4px;
  overflow: hidden;

  ${above('md')(css`
    margin-bottom: 0;
    margin-left: 4px;
  `)}
`

/*
const SShowMore = styled.button`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.darkGray};
  border: unset;
  border-bottom: 1px dashed ${colors.middleGray};
  background-color: unset;
  margin-top: 4px;
  padding: 0;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`*/

export const STitle = styled(SH4)`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
`

export const SResultItemsContainer = styled(Box)`
  display: flex;
  flex-direction: column;

  ${above('md')(css`
    flex-direction: row;
    margin-bottom: 28px;
  `)}
`

export const SResultItemContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  ${above('md')(css`
    margin-bottom: 0;
    margin-right: 54px;
  `)}
`

export const SResultItemTitle = styled(STypographyDefault)`
  font-size: 14px;
  line-height: 20px;
  color: ${colors.darkGray};
`

export const SResultItemValue = styled(STypographyDefault)`
  font-weight: 600;
  font-size: 20px;
  line-height: 26px;
  color: ${colors.graphite};
  margin-bottom: 4px;

  ${above('md')(css`
    line-height: 24px;
  `)}
`

export const SContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-bottom: 22px;

  ${above('md')(css`
    margin-bottom: 44px;
  `)}
`

export const STopContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;

  ${above('md')(css`
    flex-direction: row;
    margin-bottom: 40px;
  `)}

  ${above('xl')(css`
    height: 56px;
  `)}
`

export const SInputContainer = styled(Box)`
  width: 100%;
  margin-bottom: 40px;

  &:last-of-type {
    margin-bottom: 24px;
  }

  ${above('md')(css`
    margin-bottom: 40px;

    &:last-of-type {
      margin-bottom: 0;
    }
  `)}

  ${above('xl')(css`
    width: auto;
    min-width: 200px;
  `)}
`
